module.exports = {"button":{"addTube":"Add Tube","addFin":"Add Fin","createDrawing":"Create Drawing","addPlate":"Add Plate","update":"Update","back":"Back","add":"Add","submit":"Submit"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/button.json
// module id = 543
// module chunks = 69